import { render, staticRenderFns } from "./WorkerAgeRangeAssignments.vue?vue&type=template&id=ccdddfca&scoped=true&"
import script from "./WorkerAgeRangeAssignments.vue?vue&type=script&lang=js&"
export * from "./WorkerAgeRangeAssignments.vue?vue&type=script&lang=js&"
import style0 from "./WorkerAgeRangeAssignments.vue?vue&type=style&index=0&id=ccdddfca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccdddfca",
  null
  
)

export default component.exports